import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { columnsModel } from 'src/app/models/customer.model';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { BatchAlertService } from '../../services/batch-alert.service';
import { CreateAlertProgressModalComponent } from '../common/create-alert-progress-modal/create-alert-progress-modal.component';
import * as Constants from '../../models/Constants';

// Need to be removed once feature work done for the same.
//Current Batch Alert Table
export interface CurrentBatch {
  batchId: number;
  created: string;
  createdBy: string;
  start: string;
  end: string;
  appliedTo: number;
  title: string;
  description: string;
  fileName: string;
}

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {
  alertTypes :any[] = [];
  customerSearchForm: FormGroup = new FormGroup({});
 
  
  totalRecords: number = 8;
  CURRENT = 'current';
  ARCHIVED = 'archived';
  DELETE = 'delete';
  CREATE = 'create';

  

  public deleteColumns: columnsModel[] = [
    { field: 'batchId', header: 'Batch ID', width: 3 },
    { field: 'deleted', header: 'Deleted', width: 4 },
    { field: 'deletedBy', header: 'Deleted By', width: 6 },
    { field: 'created', header: 'Created', width: 4 },
    { field: 'createdBy', header: 'Created By', width: 6 },
    { field: 'start', header: 'Start', width: 4 },
    { field: 'end', header: 'End', width: 4 },
    { field: 'appliedTo', header: 'Applied To', width: 1 },
    { field: 'title', header: 'Title', width: 6 },
    { field: 'description', header: 'Description', width: 6 }
  ];
  clientId: any;
  selectedRow:any = null;
  constructor(
    public dialog: MatDialog,
    public rootService: RootScopeService,
    public customerService: CustBusService,
    public apiService : ApiService,
    public batchAlertService : BatchAlertService
  ) {
  }

  ngOnInit(): void {
    if(this.customerService.clients && this.customerService.clients.length >0 && !this.batchAlertService.adminForm.get('clientId')?.value){
      this.batchAlertService.clientId = this.customerService.clients[0]['clientId'];
      this.batchAlertService.adminForm.get('clientId')?.setValue(this.customerService.clients[0]['clientId']);
    }
    this.getData();
  }


 /**
 * This method is called when the user selects a Left Nav item from the Batch Alerts Section.
 * It stores the value of the selected nav link so that when switching back from another tab,
 * the selected link's value is restored.
 * @param link The selected navigation link.
 */
  onLeftNavSelectionChange(link) {
    this.batchAlertService.leftNavBatchMenu?.forEach(item => item.isActive = false);
    let selectedLink = this.batchAlertService.leftNavBatchMenu?.find(item => item?.title == link?.title);
    if (selectedLink) {
      selectedLink.isActive = true;
    }
    this.rootService.openViewParticipant = false;
  }
  
  onClientChange(evnt) {
    this.batchAlertService.createAlertForm.reset();
    this.batchAlertService.clientId = this.batchAlertService.adminForm.value.clientId;
    this.batchAlertService.currentBatchSelectedRow = null;
    this.batchAlertService.deleteBatchAlertMsgSuccess = false;
    this.batchAlertService.deleteBatchAlertMsgFail = false;
    this.batchAlertService.deletedBatchAlertDetail = null;
    this.batchAlertService.openCurrentBatchFilterDialog = false;
    this.batchAlertService.filterCurrentBatchAlertFormData = null;
    this.batchAlertService.filteronCurrentBatchAlertApplied = false;
    this.getData();
    this.selectedRow = !this.selectedRow;
    this.rootService.openViewParticipant = false;
  }

  getData(){
    this.batchAlertService.getAlertTypes(this.batchAlertService.clientId);
    this.batchAlertService.getDataForCurrentBatchAlert(this.batchAlertService.clientId);
    this.batchAlertService.getDataforArchivedAlert(this.batchAlertService.clientId);
    this.batchAlertService.getDataforDeletedBatchAlert(this.batchAlertService.clientId);
  }

  
/**
 * This method checks if a specific Batch Alert type is active.
 * It searches through the leftNavBatchMenu for an item matching the specified type and returns true if found active.
 * @param type The type of the Batch Alert to check ('Current', 'Deleted', 'Create', 'Archived').
 * @returns The active Batch Alert item if found, otherwise false.
 */
  isBatchAlertActive(type: string) {
    switch (type) {
      case this.CURRENT:
        return this.batchAlertService.leftNavBatchMenu?.find(item => item?.title === Constants.BATCH_ALERT_LEFT_NAV_MENU.CURRENT_BATCH_ALERT && item?.isActive === true);
      case this.DELETE:
        return this.batchAlertService.leftNavBatchMenu?.find(item => item?.title === Constants.BATCH_ALERT_LEFT_NAV_MENU.DELETE_BATCH_ALERT && item?.isActive === true);
      case this.CREATE:
        return this.batchAlertService.leftNavBatchMenu?.find(item => item?.title === Constants.BATCH_ALERT_LEFT_NAV_MENU.CREATE_BATCH_ALERT && item?.isActive === true);
      case this.ARCHIVED:
        return this.batchAlertService.leftNavBatchMenu?.find(item => item?.title === Constants.BATCH_ALERT_LEFT_NAV_MENU.ARCHIVED_BATCH_ALERT && item?.isActive === true);
      default:
        return false;
    }
  }
  

  /**
   * Opens a modal dialog for creating an alert progress batch.
   * 
   * The modal is configured with a custom panel class, backdrop class, 
   * and a unique ID. It is also set to prevent closing by clicking 
   * outside the modal or pressing the escape key.
   * 
   * @remarks
   * This method uses the Angular Material Dialog service to open the modal.
   * Ensure that `CreateAlertProgressModalComponent` is declared and imported 
   * properly in the module.
   */
  createAlertProgressModal() {
    this.dialog.open(CreateAlertProgressModalComponent, {
      panelClass: 'create-batch-alert',
      backdropClass: 'custom-overlay',
      id: 'createBatch',
      disableClose: true
    });   
  }


  /**
   * Handles the selection of a row in the component.
   * Updates the `selectedRow` property with the provided data.
   *
   * @param data - The data of the selected row.
   */
  rowSelection(data) {
    this.selectedRow = data;
  }

  openFilter() {
    this.rootService.openAdminFilterDialog = true;
  }

 
  
 


}
